// libs/ui/src/components/AccentButton.tsx
import React from 'react';
import { Button } from '../primitives/Button';

type AccentVariant = 'cerulean' | 'green' | 'orange' | 'crimson' | 'outline';

const VARIANT_MAP = {
  cerulean: 'primary',
  green:    'success',
  orange:   'warning',
  crimson:  'danger',
  outline:  'outline',
} as const satisfies Record<AccentVariant, React.ComponentProps<typeof Button>['variant']>;

interface AccentButtonProps extends Omit<React.ComponentProps<typeof Button>, 'variant'> {
  variant?: AccentVariant | undefined;
}

/** @deprecated Use Button from @kiips/ui directly. Kept for backward compatibility. */
export function AccentButton({ variant = 'cerulean', ...props }: AccentButtonProps) {
  return <Button variant={VARIANT_MAP[variant]} {...props} />;
}
